module.exports = __webpack_public_path__ + "img/curtain-back.48b914ba.jpg";